export type ThemePreset = 'default' | 'purple' | 'calm' | 'blumenthal' | 'releve';

export interface ThemeManifest {
  logos: {
    long: string;
    name: string;
  };
}

const DEFAULT_THEME: ThemeManifest = {
  logos: {
    long: "/releve_long_black.svg",
    name: "/releve_name_black.svg",
  },
};

const PURPLE_THEME: ThemeManifest = {
  logos: {
    long: "/releve_long_white.svg",
    name: "/releve_name_white.svg",
  },
};

// Dark chrome — white logos, same as purple.
const BLUMENTHAL_THEME: ThemeManifest = {
  logos: {
    long: "/releve_long_white.svg",
    name: "/releve_name_white.svg",
  },
};

const THEMES = {
  default: DEFAULT_THEME,
  purple: PURPLE_THEME,
  // Light rail — the default (black) logos are correct.
  calm: DEFAULT_THEME,
  blumenthal: BLUMENTHAL_THEME,
  // Near-black rail — white logos.
  releve: PURPLE_THEME,
} satisfies Record<ThemePreset, ThemeManifest>;

export function getTheme(preset: string): ThemeManifest {
  return THEMES[preset as ThemePreset] ?? DEFAULT_THEME;
}
